/* eslint-disable no-multi-assign */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Spin } from 'antd';
import './style.scss';
import useController from './controller';
import ContextMenu from '../ContextMenu';
import EditorHtmlComponent from '../EditorHtmlComponent';
import EditInput from '../EditInput';
import ChartEditTable from '../Chart/ChartEditTable';
import ChartTypeSettings from '../Chart/ChartTypeSettings';

const PageEditor = () => {
  const { state, setState, onUpdateHtmlComponent } = useController({
    canvas: null,
    currentState: null,
    isShowAlign: false,
    isEdit: false,
    editObj: null,
    alignPosition: { top: 0, left: 0 },
    editGroup: null,
    isGetPageContent: false,
  });

  return (
    <div className="page mo-editor__page" id="canvas-view">
      <div
        style={{
          display: state.isGetPageContent ? 'flex' : 'none',
          width: '100%',
          height: 'calc(100vh - 56px)',
          position: 'absolute',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 2,
        }}
      >
        <Spin spinning size="large" />
      </div>

      <div>
        <canvas id="canvas" />
        {state.isShowChartEdit && (
          <ChartEditTable
            editorInfo={state.editorInformation}
            onUpdate={onUpdateHtmlComponent}
            onClose={() => setState({ isShowChartEdit: false })}
          />
        )}
      </div>
      {state.isShowMenu && <ContextMenu isShow={state.isShowMenu} position={state.menuPosition} />}
      {state.isShowEditor && (
        <EditorHtmlComponent onUpdate={onUpdateHtmlComponent} editorInfo={state.editorInformation} />
      )}
      <ChartTypeSettings
        isShow={state.isShowChart}
        editorInfo={state.editorInformation}
        position={state.chartPosition}
        onUpdate={onUpdateHtmlComponent}
        onOpen={(obj) => {
          setState({
            isShowChartEdit: true,
            isShowChart: false,
            chartPosition: { left: 999999, top: 999999 },
            editorInformation: { data: obj.htmlContent },
          });
        }}
      />
      <EditInput
        isShow={state.isEdit}
        position={state.editPosition}
        styles={state.editStyle}
        editText={state.editText}
      />
      {/* <AlignmentSetting isShow={state.isShowAlign} position={state.alignPosition} /> */}
    </div>
  );
};

export default PageEditor;
